export default function BrandMark() {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 9, minWidth: 0 }}>
      <svg className="lwt-brand-mark" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true" style={{ width: 22, height: 22, flex: "0 0 auto" }}>
        <path d="M4 18 9 11 13 14 20 5" />
        <circle cx="20" cy="5" r="1.6" fill="currentColor" />
      </svg>
      <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>LIGHTWEIGHT TERMINAL</span>
    </span>
  );
}
